import React from "react";
import "./styles.css";
import spinner from "../../img/spinner.svg"

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <img src={spinner} alt="Loading..." className="spinner" />
    </div>
  );
};

export default LoadingScreen;
